<template>
  <div>
    <v-flex>
      <v-layout justify-center>
        <v-btn 
          round 
          large 
          @click="$store.state.locationdialog = true">
          Lisää kohde
        </v-btn>
      </v-layout>
    </v-flex>
    <v-dialog 
      v-model="$store.state.locationdialog" 
      fullscreen>
      <v-card v-if="$store.state.locationdialog">
        <v-toolbar flat>
          <v-text-field 
            v-model="$store.state.locationsearch" 
            autofocus 
            placeholder="Etsi kohde..." 
            @keyup.enter.native="blur" />
          <v-btn 
            icon 
            @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
        <location-list-data />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
	methods: {
		close() {
			this.$store.state.locationdialog = false
		},
		blur(event) {
			event.target.blur()
		}
	}
}
</script>
